import {
  Box,
  Button,
  Typography,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import styles from 'src/components/Dialogs/Payments/PaymentsDialog.scss'

const PrivacyAndTerms = (): JSX.Element => {
  const { palette } = useTheme()

  return (
    <Box className={styles.paymentsDialogCardPrivacyAndTermsContainer}>
      <Button
        sx={{ color: `${palette.gray1.main} !important` }}
        href="https://www.sikahealth.com/privacy-policy"
        target="_blank"
        variant="text"
      >
        <Typography
          className={styles.paymentsDialogCardPrivacyAndTerms}
          color="palette.gray1"
          fontWeight="regular"
          variant="body3"
        >
          Sika&apos;s Privacy
        </Typography>
      </Button>
      <Typography
        color="palette.gray1"
        fontWeight="regular"
        variant="body3"
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        and
      </Typography>
      <Button
        sx={{ color: `${palette.gray1.main} !important` }}
        href="https://www.sikahealth.com/terms-of-service"
        target="_blank"
        variant="text"
      >
        <Typography
          className={styles.paymentsDialogCardPrivacyAndTerms}
          color="palette.gray1"
          fontWeight="regular"
          variant="body3"
        >
          Terms of Service
        </Typography>
      </Button>
    </Box>
  )
}

export default PrivacyAndTerms
